import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { alt: "generic button" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InlineSvg = _resolveComponent("InlineSvg");
    return (_openBlock(), _createElementBlock("button", _hoisted_1, [
        _createVNode(_component_InlineSvg, {
            src: _ctx.src,
            fill: _ctx.color,
            onMouseover: _ctx.onMouseHoverIn,
            onMouseout: _ctx.onMouseHoverOut
        }, null, 8, ["src", "fill", "onMouseover", "onMouseout"])
    ]));
}
